// URL base para todas las llamadas a la API.
// Con el proxy de Nginx (producción) se deja vacío para usar rutas relativas (/api/...).
// Si se definen las vars de entorno (dev local sin proxy), se usa la URL completa.
const host = process.env.REACT_APP_API_HOST;
const port = process.env.REACT_APP_API_PORT;
const protocol = process.env.REACT_APP_API_PROTOCOL;

export const API_BASE = host
  ? `${protocol || 'http'}://${host}${port ? ':' + port : ''}`
  : '';
